import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { clearAlerts } from "../action/alert";

/**
 * Clears global alert/snackbar state whenever the provided value changes.
 * Skips the initial render to avoid dismissing alerts shown for the
 * initial tab/page load.
 */
const useClearAlertsOnChange = (value) => {
  const dispatch = useDispatch();
  const previousValueRef = useRef();

  useEffect(() => {
    if (previousValueRef.current !== undefined && previousValueRef.current !== value) {
      dispatch(clearAlerts());
    }
    previousValueRef.current = value;
  }, [dispatch, value]);
};

export default useClearAlertsOnChange;
